export const IQACActions = {
    GET_IQAC: "GET_IQAC",
    SET_IQAC: "SET_IQAC",
  };